'use strict';
define([
    '../../../../lib/domQ'
], function (domQ) {

    function Carousel(el, options) {
        this.carousel = el;
        this.options = this.getOptions(options);
    }

    Carousel.TYPES = {
        HORIZONTAL: 'horizontal',
        VERTICAL: 'vertical'
    };

    Carousel.prototype = {

        /*
         * Set timer as 0 if no automatic transition required.
         * Set disableBtnCss as 'hdr-infinite-loop' for looping the carousel.
         */

        /**
         * Returns carousel configuration options
         * @param {Object} custom configuration options
         * @returns {Object} carousel configuration options
         */
        getOptions: function (options) {
            var defaultOptions = {
                wrapper: '.navigation-hdr-carousel__content',
                slider: '.navigation-hdr-carousel__slides',
                slide: '.navigation-hdr-carousel__slides li',
                multiple: true,
                previousBtn: '.navigation-hdr-carousel__btn--previous',
                nextBtn: '.navigation-hdr-carousel__btn--next',
                type: 'horizontal',
                disableBtnCss: 'navigation-hdr-ctrl--link-disable'
            };

            return Object.assign(defaultOptions, options);
        },


        /**
         * Initialize carousel component by setting initial state and behavior
         */
        init: function () {
            this.wrapper = this.carousel.querySelector(this.options.wrapper);
            this.wrapperSize = this.options.type === Carousel.TYPES.HORIZONTAL ? this.wrapper.offsetWidth : this.wrapper.offsetHeight;

            this.slider = this.carousel.querySelector(this.options.slider);

            this.previousBtn = this.carousel.querySelector(this.options.previousBtn);
            this.nextBtn = this.carousel.querySelector(this.options.nextBtn);

            this.slideIndex = 0;

            this.totalSlides = this.carousel.querySelectorAll(this.options.slide).length;

            this.slideSize = this.options.type === Carousel.TYPES.HORIZONTAL ? this.carousel.querySelector(this.options.slide).offsetWidth : this.carousel.querySelector(this.options.slide).offsetHeight;
            this.slidesinView = Math.floor(this.wrapperSize / this.slideSize);

            // bind carousel events
            this.bindEvents();

            // set default next / previous link state
            this.toggleNavBtnState();
        },

        bindEvents: function () {
            var slideNext = this.slideNext.bind(this),
                slidePrevious = this.slidePrevious.bind(this);

            this.nextBtn.addEventListener('click', slideNext);
            this.previousBtn.addEventListener('click', slidePrevious);

            /* TBD: need to undersatnd resizing logic
            window.addEventListener('resize', function () {
                self.width = self.slides.offsetWidth;
            });
            */
        },

        /**
         * Toggles next and previous link states
         */
        toggleNavBtnState: function () {
            this.isFirstSlide() ? this.disablePreviousBtn() : this.enablePreviousBtn();
            this.isLastSlide() ? this.disableNextBtn() : this.enableNextBtn();
        },

        /**
         * Move carousel to next slide
         * @returns {Boolean} slide status. Returns false if current slide is last slide in carousel
         */
        slideNext: function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.isLastSlide()) {
                return false;
            }

            this.slideIndex += 1;
            this.toggleNavBtnState();
            this.animate();

            return true;
        },

        /**
         * Move carousel to previous slide
         * @returns {Boolean} slide status. Returns false if current slide is first slide in carousel
         */
        slidePrevious: function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.isFirstSlide()) {
                return false;
            }

            this.slideIndex -= 1;
            this.toggleNavBtnState();
            this.animate();

            return true;
        },

        /**
         * Checks if current slide is first slide of carousel
         * @returns {Boolean} Returns true if current slide is first slide of carousel
         */
        isFirstSlide: function () {
            return this.slideIndex === 0;
        },

        /**
         * Checks if current slide is last slide of carousel
         * @returns {Boolean} Returns true if current slide is last slide of carousel
         */
        isLastSlide: function () {
            if (this.options.multiple) {
                return this.slideIndex >= (Math.ceil(this.totalSlides / this.slidesinView) - 1);
            } else {
                return this.slideIndex >= (this.totalSlides - 1);
            }
        },

        /**
         * Disable next slide link
         */
        disableNextBtn: function () {
            domQ(this.nextBtn).addClass(this.options.disableBtnCss);
        },

        /**
         * Enable next slide link
         */
        enableNextBtn: function () {
            domQ(this.nextBtn).removeClass(this.options.disableBtnCss);
        },

        /**
         * Disable previous slide link
         */
        disablePreviousBtn: function () {
            domQ(this.previousBtn).addClass(this.options.disableBtnCss);
        },

        /**
         * Enable previous slide link
         */
        enablePreviousBtn: function () {
            domQ(this.previousBtn).removeClass(this.options.disableBtnCss);
        },

        /**
         * Animate carousel slide
         */
        animate: function () {
            if (this.options.type === Carousel.TYPES.HORIZONTAL) {
                this.slider.style.transform = 'translateX(' + this.getPosition() + 'px)';
            } else {
                this.slider.style.transform = 'translateY(' + this.getPosition() + 'px)';
            }
        },

        /**
         * Returns animation value to slide carousel
        * @returns {Number}
         */
        getPosition: function () {
            var position = 0;

            if (this.options.multiple) {
                position = -(this.slideSize * this.slideIndex * this.slidesinView);
            } else {
                position = -(this.slideSize * this.slideIndex);
            }

            return position;
        }
    };

    return Carousel;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/carousel/Index.js